import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function getMonthsBetween(startDate: string, endDate: string): number {
  return dayjs(endDate).utcOffset(0).add(1, 'day').diff(startDate, 'month');
}
